import 'rc-banner-anim/assets/index.css';
import React, { Children } from 'react';
import QueueAnim from 'rc-queue-anim';
import BannerAnim from 'rc-banner-anim';
import { Button, Space, Row, Col } from 'antd';
import { BannerDataSource } from './data';

const { Element } = BannerAnim;
const { BgElement } = Element;

class Banner extends React.PureComponent {
  getDuration = (e) => {
    if (e.key === 'map') {
      return 800;
    }
    return 1000;
  };
  render() {
    const { isMobile } = this.props;
    const bannerChildren = BannerDataSource.map((item, i) => {
      const TITLE = <div className='banner-content'>
        <h3>{item.title}</h3>
        <h3>{item.subTitle}</h3>
        {!isMobile && <><div className='banner-content-desc'>{item.desc}</div>
          <div className='banner-content-btns'>
            <Space size={16}>
              {item.btns.map(btn => {
                return <Button {...btn}>{btn.title}</Button>;
              })}
            </Space>
          </div></>}

        {isMobile ? <Space className='banner-tab' direction="vertical" size={16}>
            {item.bannerTabs.map(tab => {
              return <div className='banner-tab-item'><img alt='apexDB banner' src={tab.icon} />{tab.title}</div>;
            })}
        </Space> : <Row gutter={24} justify="center" className='banner-tab'>
          {item.bannerTabs.map(tab => {
            return <Col span={8} key={tab.title}>
              <div className='banner-tab-item'><img alt='apexDB banner' src={tab.icon} />{tab.title}</div>
            </Col>;
          })}
        </Row>}

      </div>
      return (
        <Element key={i.toString()}>
          <QueueAnim
            key="text"
            className={item.className}
            ease={['easeOutCubic', 'easeInQuad']}
            type={item.queueAnim || 'left'}
          >
            {TITLE}
          </QueueAnim>
        </Element >);
    });
    return (
      <div className="banner page-wrapper" >
        <div className="page">
          <BannerAnim type="across" duration={550} ease="easeInOutQuint">
            {bannerChildren}
          </BannerAnim>
        </div>
      </div>
    );
  }
}

export default Banner;
